import { Text } from '@chakra-ui/react'
import * as React from 'react'

import { SoundOnButtonL } from '../icons'
import { vw } from '../../styles/theme'
import Button, { ButtonProps } from './Button'
import SVG from '../common/SVG'
import SoundOffButtonL from '../icons/SoundOffButtonL'

export type ButtonSoundLProps = ButtonProps & {
  isOn: boolean
}

const soundOn = <SoundOnButtonL />
const soundOff = <SoundOffButtonL />

const ButtonSoundL: React.FC<ButtonSoundLProps> = ({ isOn, ...others }) => {
  const icon = isOn ? soundOn : soundOff
  return (
    <>
      <Button
        variant="unstyled"
        w={[vw(100), '130px']}
        h={[vw(137), '177px']}
        border="none"
        display="inline-flex"
        flexDirection="column"
        justifyContent="space-between"
        _hover={{
          color: '#666',
          'svg path': {
            fill: '#666',
            stroke: '#666',
          },
          'svg rect': {
            stroke: '#666',
          },
        }}
        {...others}
      >
        <SVG as="span" w={[vw(100), '130px']} h={[vw(100), '130px']} svg={icon} />
        <Text as="span" fontSize={[vw(12), '12px']} lineHeight="1" fontWeight="medium">
          {'SOUND '}
          <Text as="span" fontWeight="bold">{`${isOn ? 'ON' : 'OFF'}`}</Text>
        </Text>
      </Button>
    </>
  )
}

export default ButtonSoundL
